import { Link } from "@tanstack/react-router";

export function PostCTA() {
  return (
    <section aria-labelledby="post-cta" className="bg-background">
      <div className="mx-auto max-w-6xl px-6 md:px-12 section-y">
        <div className="flex flex-col items-start gap-6 rounded-lg bg-brand-button p-8 text-brand-button-foreground md:flex-row md:items-center md:justify-between md:p-12">
          <div className="max-w-2xl">
            <p
              id="post-cta"
              className="font-display text-2xl font-extrabold leading-tight text-brand-button-foreground md:text-3xl"
            >
              Sie planen eine Kampagne oder möchten politisch wirksam kommunizieren?
            </p>
            <p className="mt-3 font-body text-sm leading-relaxed">
              Wir entwickeln mit Ihnen Strategie, Botschaft und Umsetzung — vom
              Konzept bis zur Wahl.
            </p>
          </div>
          <Link
            to="/kontakt"
            className="inline-flex h-11 items-center justify-center rounded-md bg-primary px-6 font-display text-sm font-extrabold text-primary-foreground transition-opacity hover:opacity-90"
          >
            Erstgespräch vereinbaren
          </Link>
        </div>
      </div>
    </section>
  );
}
